var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-menu g3" }, [
    _c("ul", [
      _c("li", { staticClass: "head" }, [_vm._v("Simulation")]),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("router-link", { attrs: { to: _vm.createLink("demand") } }, [
            _vm._v("Demand"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("router-link", { attrs: { to: _vm.createLink("materials") } }, [
            _vm._v("Materials"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.$store.state.dataView.forecast.typeName === "Study"
        ? _c(
            "li",
            [
              _c(
                "router-link",
                { attrs: { to: _vm.createLink("distribution") } },
                [_vm._v("Distribution")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.state.dataView.forecast.typeName === "Study"
        ? _c(
            "li",
            [
              _c("router-link", { attrs: { to: _vm.createLink("events") } }, [
                _vm._v("Events"),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.$store.state.member.isAnonymous
        ? _c(
            "li",
            [
              _c("router-link", { attrs: { to: _vm.createLink("share") } }, [
                _vm._v("Share"),
              ]),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }